import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Contract} from '../../../shared/interface/contract';
import {DocumentAddDialogComponent} from '../../documents/document-add-dialog/document-add-dialog.component';
import {
  FILE_TYPE_CONTRACT,
  FILE_TYPE_CONTRACT_TERMINATION,
  FILE_TYPE_CONTRACT_WITH_EMPLOYEE,
  INVOICE_DOCUMENT_TYPE_CREDIT
} from '../../../shared/services/dict.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ContractService} from '../../../shared/services/contract.service';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {HttpErrorResponse} from '@angular/common/http';
import {ListResponse} from "../../../shared/interface/response/list-response";
import {Document} from "../../../shared/interface/document";
import {User} from "../../../shared/interface/user";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {Registration} from "../../../shared/interface/registration";
import {Ofwca} from "../../../shared/interface/ofwca";

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.scss']
})
export class ContractListComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() contracts: Observable<Contract[]>;
  @Input() ofwcaId?: string = null;
  @Input() excludeColumns: string[] = [];
  @Input() displayedColumnIn: string[] = null;
  @Output() contractDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource: MatTableDataSource<Contract>;
  displayedColumns: string[] = ['number', 'type', 'concludeDate', 'company', 'status', 'activeFrom',
    'activeTo', 'assetsRegional', 'actions' ];

  userPermissions: ReplaySubject<UserPermissions>;
  documents: Document[] = [];
  ofwca: Ofwca = null;
  documentsDownloaded = false;
  updateInProgress = false;


  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private contractService: ContractService,
    private auth: AuthService,
    private ofwcaService: OfwcaService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.dataSource = new MatTableDataSource<Contract>([]);
    this.updateInProgress = false;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.contracts
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((contracts: Contract[]) => this.dataSource.data = contracts);

    if (this.displayedColumnIn !== null){
      this.displayedColumns = this.displayedColumnIn;
    } else {
      this.displayedColumns = this.displayedColumns.filter((e: string) => {
        return this.excludeColumns.indexOf(e) === -1;
      });
    }

    if (this.ofwcaId !== null) {
      this.ofwcaService.getOfwcaDocuments(this.ofwcaId)
        .subscribe((documents: ListResponse<Document>) => {
          this.documents = documents.items;
          this.documentsDownloaded = true;
        });
      this.ofwcaService.get(this.ofwcaId)
        .subscribe((ofwca: Ofwca) => {
          this.ofwca = ofwca;
        });
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  loadDocuments(uuid: string): boolean {
    let $val = false;
    this.documents.forEach((value: Document) => {
       if (value.type.key === FILE_TYPE_CONTRACT_WITH_EMPLOYEE)
         {
           if (value.contract.uuid === uuid)
           {
             $val = true;
           }
         }
    });
     return $val;
  }

  addDocument(contract: Contract): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        contractObject: contract,
        types: [FILE_TYPE_CONTRACT_TERMINATION, FILE_TYPE_CONTRACT],
      },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
   loadListData(): void {
    this.ofwcaService.getOfwcaContractsRegistrationsPartnership(this.ofwcaId)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.dataSource.data = contracts.items;
      });
  }

  formChanged(
    $event: MatSlideToggleChange,
    contract: Contract,
    formData: { released: boolean; returned: boolean; contractUuid: string }
  ): void {
    this.updateInProgress = true;

    this.ofwcaService.updateCheckedContract(this.ofwcaId, formData)
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano umowe', '', {duration: 2000});
        this.ofwcaService.get(this.ofwcaId)
          .subscribe((ofwca: Ofwca) => {
            this.ofwca = ofwca;
          });
        this.loadListData();
        this.updateInProgress = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.updateInProgress = false;
      });
  }

  deleteContract(contract: Contract): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć umowę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.contractService.deleteContract(contract.uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto umowę', '', {duration: 2000});
              this.contractDeleted.emit(true);
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }
}
